import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-success"
}

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CopyText',
  props: {
    string: {}
  },
  setup(__props: any) {

const props = __props;
const copied = ref(false);

function copy() {
  if (copied.value) return;
  copied.value = true;
  setTimeout(() => (copied.value = false), 2000);
  navigator.clipboard.writeText(props.string ?? "");
}

return (_ctx: any,_cache: any) => {
  const _component_PhIcons = _resolveComponent("PhIcons")!

  return (copied.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("span", { class: "fas fa-check" }, null, -1),
        _createElementVNode("small", { class: "" }, " Copiado!", -1)
      ]))]))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "btn btn-sm btn-white lift border-0",
        onClick: copy
      }, [
        (_ctx.$slots.icon)
          ? _renderSlot(_ctx.$slots, "icon", {}, undefined, undefined, 0)
          : (_openBlock(), _createBlock(_component_PhIcons, {
              key: 1,
              name: "share",
              size: 20
            }))
      ]))
}
}

})